import type * as Types from '~/gql/graphql';

import { gql } from 'urql';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ProjectTeamsMultiSelect_TeamFragment = { id: string, name: string, color: string };

export type GetProjectTeamsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['uuid']['input'];
}>;


export type GetProjectTeamsQuery = { projects_by_pk?: { id: string, teams: Array<{ id: string, name: string, color: string }> } | null };

export const ProjectTeamsMultiSelect_TeamFragmentDoc = gql`
    fragment ProjectTeamsMultiSelect_team on teams {
  id
  name
  color
}
    `;
export const GetProjectTeamsDocument = gql`
    query getProjectTeams($projectId: uuid!) {
  projects_by_pk(id: $projectId) {
    id
    teams {
      ...ProjectTeamsMultiSelect_team
    }
  }
}
    ${ProjectTeamsMultiSelect_TeamFragmentDoc}`;

export function useGetProjectTeamsQuery(options: Omit<Urql.UseQueryArgs<GetProjectTeamsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProjectTeamsQuery, GetProjectTeamsQueryVariables>({ query: GetProjectTeamsDocument, ...options });
};